'use client'

import { useEffect } from 'react'

export function SectionTracking() {
  useEffect(() => {
    // Add tracking attributes to all sections after page loads
    const addTrackingAttributes = () => {
      // Hero section
      const hero = document.querySelector('section:first-of-type')
      if (hero) {
        hero.setAttribute('data-section', 'hero')
        hero.setAttribute('data-title', 'Hero - Home Page')
      }

      // Find sections by their content
      const sections = document.querySelectorAll('section')
      sections.forEach((section) => {
        const text = section.textContent || ''
        
        if (text.includes('What Our Customers Say')) {
          section.setAttribute('data-section', 'reviews')
          section.setAttribute('data-title', 'Customer Reviews')
        } else if (text.includes('From Factory to Your Foundation')) {
          section.setAttribute('data-section', 'complete-services')
          section.setAttribute('data-title', 'Complete Installation Services')
        } else if (text.includes('Floor Plans')) {
          section.setAttribute('data-section', 'floor-plans')
          section.setAttribute('data-title', 'Featured Floor Plans')
        } else if (text.includes('Standard Service Area')) {
          section.setAttribute('data-section', 'service-area')
          section.setAttribute('data-title', 'Service Area Map')
        } else if (text.includes('Ready to Find Your Perfect Home')) {
          section.setAttribute('data-section', 'cta')
          section.setAttribute('data-title', 'Call to Action')
        } else if (text.includes('Why Southwest Homes')) {
          section.setAttribute('data-section', 'why-choose')
          section.setAttribute('data-title', 'Why Choose Southwest Homes')
        } else if (text.includes('site preparation')) {
          section.setAttribute('data-section', 'site-prep')
          section.setAttribute('data-title', 'Site Preparation Services')
        }
      })

      // Add to main content divs
      const mainDivs = document.querySelectorAll('main > div, .container > div')
      mainDivs.forEach((div, index) => {
        if (!div.getAttribute('data-section')) {
          const heading = div.querySelector('h2, h3')
          if (heading) {
            const title = heading.textContent?.trim() || `Section ${index + 1}`
            div.setAttribute('data-section', `section-${index}`)
            div.setAttribute('data-title', title)
          }
        }
      })
    }

    // Run after a short delay to ensure DOM is ready
    setTimeout(addTrackingAttributes, 500)
    
    // Also run on route changes
    const observer = new MutationObserver(() => {
      setTimeout(addTrackingAttributes, 500)
    })
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
    
    return () => observer.disconnect()
  }, [])

  return null
}